// The address an invite email's button carries (`/?invite=<email>`). It is read once as the app
// loads and wiped from the address bar straight away: this module loads with the store, before
// analytics starts, so the address never rides along on a pageview. Login prefills it once and
// then forgets it, and signing out forgets it too, so it never prefills a later sign-in.

let invited = takeInvite();

function takeInvite(): string {
  try {
    const url = new URL(window.location.href);
    const email = url.searchParams.get("invite");
    if (email === null) return "";
    url.searchParams.delete("invite");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
    return email.trim().slice(0, 254);
  } catch {
    return "";
  }
}

/** The invited address, or "" once it has been used or there was none. */
export function invitedEmail(): string {
  return invited;
}

export function forgetInvite(): void {
  invited = "";
}
